import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { RepositoryService } from 'src/app/service/repository.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ToastService } from 'angular-toastify';
import { NgxSpinnerService } from 'ngx-spinner';
import { AWS_IntendeOptions, JIRA_BOARD_PROJECT_Name } from 'src/app/constant/constant';
import { MatTabGroup } from '@angular/material/tabs';

@Component({
  selector: 'app-awsiamroleservicerequest',
  templateUrl: './awsiamroleservicerequest.component.html',
  styleUrls: ['./awsiamroleservicerequest.component.css']
})
export class AwsiamroleservicerequestComponent implements OnInit {
  cloudForm: FormGroup;
  awsAccountName: any = [];
  filteredAWSAccountName: any[] = []
  removable: boolean = true;
  addOnBlur: boolean = true;
  visible: boolean = true;
  selectable: boolean = true;
  summary: string;
  projectName: string = JIRA_BOARD_PROJECT_Name.AWS;
  @Input() tabGroup!: MatTabGroup
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  constructor(private fb: FormBuilder, private rs: RepositoryService, private _toastService: ToastService, private spinner: NgxSpinnerService) { }
  intendeOptions: Array<any> = AWS_IntendeOptions
  ngOnInit(): void {
    this.cloudForm = this.fb.group({
      accountName: ['', [Validators.required]],
      intendedUse: ['', [Validators.required]],
      policyToAttach: this.fb.array([], [Validators.required]),
      ServiceorPrincipaltoTrust: [''],
      appid: [''],
      bu: [''],
      bc: [''],
      rc: [''],
      billingOwner: [''],
      techOwner: ['']
    })
    this.LoadAllAWSAccount();
    this.cloudForm.get('intendedUse')!.valueChanges.subscribe(value => {
      const ServiceorPrincipaltoTrustControl = this.cloudForm.get('ServiceorPrincipaltoTrust');
      if (value === 'Application Authentication') {
        ServiceorPrincipaltoTrustControl.setValidators([Validators.required]);
      } else {
        ServiceorPrincipaltoTrustControl.clearValidators();
      }
      ServiceorPrincipaltoTrustControl.updateValueAndValidity();
    });
    this.cloudForm.get('accountName')!.valueChanges.subscribe(res => {
      let AWSAccount = this.awsAccountName.find((items: any) => {
        return items?.accountName === res
      });
      if (AWSAccount) {
        this.cloudForm.controls.bu.setValue(AWSAccount['BU']);
        this.cloudForm.controls.bc.setValue(AWSAccount['BC']);
        this.cloudForm.controls.rc.setValue(AWSAccount['RC']);
        this.cloudForm.controls.billingOwner.setValue(AWSAccount['accountOwners']);
        this.cloudForm.controls.techOwner.setValue(AWSAccount['accountOwners']);
      }
    })
  }


  /**Load All AWS Accounts */
  LoadAllAWSAccount() {
    this.spinner.show()
    this.rs.getAWSAccounts("All", "List").subscribe({
      next: (res) => {
        this.awsAccountName = res['Items'];
        this.filteredAWSAccountName = [...this.awsAccountName];
        this.spinner.hide();
      },
      error: (error) => {
        this._toastService.error(error?.message);
        this.spinner.hide();
      }
    })

  }

  handleFilteredReturn(filteredData: any) {
    this.filteredAWSAccountName = filteredData
  }


  addChip(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const policyToAttachArray = this.cloudForm.get('policyToAttach') as FormArray;
      policyToAttachArray.push(this.fb.control({ name: value.trim() }));

    }
    if (input) {
      input.value = '';
    }
  }



  /**Handles removing chips */
  removeChip(value: { name: string } | null | undefined): void {
    let index: number;
    if (!value || !value.name) {
      return; // Exit if value or name is null/undefined
    }
    const policyToAttachArray = this.cloudForm?.get('policyToAttach') as FormArray;

    // Find the index of the chip to be removed
    index = policyToAttachArray.value.findIndex((item: any) => item.name === value.name);
    if (index >= 0) {
      policyToAttachArray.removeAt(index); // Use the Angular FormArray method
    }

  }
  getIntendeOptions(): string | null {
    return this.cloudForm.get('intendedUse').value
  }

  resetform(): void {
    this.cloudForm?.reset();
    this.cloudForm.setControl('policyToAttach', this.fb.array([]));
  }

  onSubmit(): void {
    this.spinner.show();
    this.summary = `Request for IAM ROLE SERVICE ${this.cloudForm.get('intendedUse').value}- ${this.cloudForm.get('accountName').value}`;
    this.rs.createCloudServiceRequest(this.projectName, this.summary, this.cloudForm.value, sessionStorage.getItem("wwid")
    ).subscribe({
      next: (res) => {
        this._toastService.success(res['message']);
        this.resetform();
        if (this.tabGroup) { this.tabGroup.selectedIndex = 1 };
        this.spinner.hide();

      },
      error: (error) => {
        this._toastService.error(error?.message || "An unexpected error occurred.");
        this.spinner.hide();

      }
    });
  }
}
